var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Epiphan {
    constructor(log) {
        // Pearl Mini has two primary channels for recording and streaming; we've also included one
        // recorder channel. The Pearl Nano has just one channel for recording and streaming.
        this.channels = {
            'Pearl Mini': {
                '1': {
                    name: 'HDMI-A',
                    type: 'local',
                    rec_enabled: false,
                    publish_enabled: false,
                    startTime: 0,
                },
                '2': {
                    name: 'HDMI-B',
                    type: 'local',
                    rec_enabled: false,
                    publish_enabled: false,
                    startTime: 0,
                },
                m1: {
                    name: 'Recorder 1',
                    publish_enabled: false,
                    rec_enabled: false,
                    recorderOnly: true,
                    type: 'local',
                    startTime: 0,
                },
            },
            'Pearl Nano': {
                '1': {
                    name: 'HDMI-A',
                    type: 'local',
                    rec_enabled: false,
                    publish_enabled: false,
                    startTime: 0,
                },
            },
        };
        this.firmwareVersion = '4.13.0i';
        this.productName = 'Pearl Mini';
        this.asyncHandlers = [
            {
                name: 'channeGet',
                path: /\/admin\/channel(m?\d)\/get_params.cgi\?(rec_enabled|publish_enabled)/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const chan = this.channels[this.productName][match[1]];
                    if (chan !== undefined) {
                        if (match[2] === 'rec_enabled') {
                            return { data: `${match[2]} = ${chan.rec_enabled ? 'on' : 'off'}` };
                        }
                        else if (match[2] === 'publish_enabled') {
                            return { data: `${match[2]} = ${chan.publish_enabled ? 'on' : 'off'}` };
                        }
                    }
                    return { data: '' };
                }),
            },
            {
                name: 'channelSet',
                path: /\/admin\/channel(m?\d)\/set_params.cgi\?(rec_enabled|publish_enabled)=(.*)/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const chan = this.channels[this.productName][match[1]];
                    const state = match[3] === 'on' ? true : false;
                    if (chan !== undefined) {
                        chan.startTime = state ? Date.now() : 0;
                        if (match[2] === 'rec_enabled') {
                            chan.rec_enabled = state;
                        }
                        else if (match[2] === 'publish_enabled') {
                            chan.publish_enabled = state;
                        }
                    }
                    return { data: '' };
                }),
            },
            {
                name: 'detectedChannels',
                path: /\/api\/(channels|recorders)$/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const channels = [];
                    if (match[1] === 'channels') {
                        // Return all channels that are not record-only.
                        for (const key of Object.keys(this.channels[this.productName])) {
                            const chan = this.channels[this.productName][key];
                            if (chan.recorderOnly === undefined || chan.recorderOnly === false) {
                                channels.push({ id: key, name: chan.name, type: chan.type });
                            }
                        }
                    }
                    else {
                        // All channels can record.
                        for (const key of Object.keys(this.channels[this.productName])) {
                            const chan = this.channels[this.productName][key];
                            channels.push({ id: key, name: chan.name, type: chan.type });
                        }
                    }
                    return { data: { status: 'ok', result: channels } };
                }),
            },
            {
                name: 'getFirmware',
                path: /\/admin\/get_params.cgi\?firmware_version/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return { data: `firmware_version = ${this.firmwareVersion}` };
                }),
            },
            {
                name: 'getRecordDuration',
                path: /\/api\/recorders\/(\d+)\/status\?_/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    // return duration in seconds
                    const chan = this.channels[this.productName][match[1]];
                    let result = {};
                    if (chan.rec_enabled) {
                        const duration = Math.round((Date.now() - chan.startTime) / 1000);
                        result = { state: 'started', duration: duration, active: '1', total: '1' };
                    }
                    else {
                        result = { state: 'stopped' };
                    }
                    return { data: JSON.stringify({ status: 'ok', result: result }) };
                }),
            },
            {
                name: 'getStreamingDuration',
                path: /\/api\/channels\/(\d+)\/publishers\/status\?_/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    // return duration in seconds
                    const chan = this.channels[this.productName][match[1]];
                    let result = {};
                    if (chan.publish_enabled) {
                        const duration = Math.round((Date.now() - this.channels[this.productName][match[1]].startTime) / 1000);
                        result = {
                            id: '0',
                            type: 'rtp-udp',
                            started: true,
                            state: 'started',
                            duration: duration,
                        };
                    }
                    else {
                        result = { id: '0', type: 'rtp-udp', started: false, state: 'stopped' };
                    }
                    return {
                        data: JSON.stringify({ status: 'ok', result: result }),
                    };
                }),
            },
            {
                name: 'productName',
                path: /\/admin\/get_params.cgi\?product_name/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return { data: `product_name = ${this.productName}` };
                }),
            },
            {
                name: 'invalid',
                path: /.+/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return { error: '', status: 404 };
                }),
            },
        ];
    }
    onConfigure(config) {
        if ((config === null || config === void 0 ? void 0 : config.modelNumber) === '-MYjPXOZG-W9axjUvMAk') {
            this.productName = 'Pearl Nano';
        }
        else {
            this.productName = 'Pearl Mini';
        }
    }
}
Epiphan.emulatorType = 'httpRequestEmulator';
Epiphan.key = '-MYjPO9d_ZoSHkztys0H';
